
import Vue from "vue";
import Component from "vue-class-component";
import { Action } from 'vuex-class';

@Component
export default class LoginCallback extends Vue {
  @Action('autoLogin', {namespace: 'user'}) autoLogin!: (accessToken: string) => Promise<void>;

  mounted(): void {
    const accessToken = this.$route.query.accessToken as string;
    const path = this.$route.query.path as string;

    // console.log("accessToken", accessToken);
    // console.log("path", path);

    this.autoLogin(accessToken).then(() => {
      this.$router.push({
        name: path || "/",
        params: { slug: this.$route.params.slug },
        query: {},
      });
    }).catch(error => {
      console.error("Login failed:", error);
      this.$router.push({
        name: "home",
        params: { slug: this.$route.params.slug },
        query: {},
      });
    });

  }
}
